/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.sysError = {};

//#endregion

//#region Update

rtAPI.sysError.write = function (statusCode, errorName, errorMessage) {
    rtAPI.loadingPanel.hide();
    if (!errorName) errorName = 'Server Error';
    //if (!errorMessage || rtAPI.debugMode == false) errorMessage = '';
    if (!errorMessage) errorMessage = '';
    var sysErrorDiv = this.getSysErrorDiv();
    sysErrorDiv.style.display = 'inline-block';
    if (!errorMessage.stack) sysErrorDiv.innerHTML = `<strong>Error Message</strong><br/>${errorName} ${statusCode}<br/>${errorMessage.replace(/\n/g, "<br />")}`;
    else sysErrorDiv.innerHTML = `<strong>Error Message</strong><br/>${statusCode}<br/>${errorName}<br/>${errorMessage.message.replace(/\n/g, "<br />")}<br/>${errorMessage.stack.replace(/\n/g, "<br />")}`;
    console.error('Error:', errorMessage);
    return { 'statusOk': false };
}

rtAPI.sysError.clear = function () {
    this.getSysErrorDiv().parentElement.style.display = 'none';
    return { 'statusOk': false };
}

//#endregion

//#region Render

rtAPI.sysError.getSysErrorDiv = function () {

    var sysErrorWrapper = document.getElementById('rtAPIErrorWrapper');
    if (!sysErrorWrapper) {
        sysErrorWrapper = document.createElement("div");
        sysErrorWrapper.id = 'rtAPIErrorWrapper';
        document.body.insertBefore(sysErrorWrapper, document.body.firstChild);
    }
    sysErrorWrapper.innerHTML = '';
    sysErrorWrapper.style.display = 'block';

    var sysErrorDiv = document.getElementById('rtAPIErrorDiv');
    if (!sysErrorDiv) {
        sysErrorDiv = document.createElement("div");
        sysErrorDiv.id = 'rtAPIErrorDiv';
        sysErrorWrapper.appendChild(sysErrorDiv);
    }

    var sysErrorSpan = document.getElementById('rtAPIErrorSpan');
    if (!sysErrorSpan) {
        sysErrorSpan = document.createElement("div");
        sysErrorSpan.id = 'rtAPIErrorSpan';
        sysErrorSpan.innerHTML = '[close]';
        sysErrorSpan.style.right = '8px';
        sysErrorSpan.style.position = 'absolute';
        sysErrorSpan.style.top = '4px';
        sysErrorSpan.style.cursor = 'pointer';
        sysErrorSpan.addEventListener('click', function () { sysErrorWrapper.style.display = 'none' });
        sysErrorWrapper.appendChild(sysErrorSpan);
    }
    return sysErrorDiv
}

//#endregion

